import React, { useState, useEffect, useCallback } from 'react'
import '../../App.css'
import { CSSTransition } from 'react-transition-group'
import { ICON_CLASSES } from '../../constants/icon.constants'

const NAV_ID = 'primary-navigation'

export const Header = () => {
  const [isNavVisible, setNavVisibility] = useState(false)
  const [isSmallScreen, setIsSmallScreen] = useState(true)
  const [small, setSmall] = useState(false)

  useEffect(() => {
    const onScroll = () => setSmall(window.pageYOffset > 1)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const handleMediaQueryChange = useCallback((mediaQuery) => {
    setIsSmallScreen(mediaQuery.matches)
    if (!mediaQuery.matches) {
      setNavVisibility(false)
    }
  }, [])

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 900px)')
    mediaQuery.addEventListener('change', handleMediaQueryChange)
    handleMediaQueryChange(mediaQuery)

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange)
    }
  }, [handleMediaQueryChange])

  const toggleNav = () => {
    if (!isSmallScreen) return
    const willClose = isNavVisible
    setNavVisibility(!isNavVisible)
    if (willClose && window.pageYOffset < 1) {
      setSmall(false)
    } else {
      setSmall(true)
    }
  }

  const closeNav = () => {
    if (isSmallScreen) {
      setNavVisibility(false)
    }
  }

  return (
    <header className={`header ${small || isNavVisible ? 'header-filled' : ''}`}>
      <a href="#introductionPanel" className="header__logo-link">
        <img src="/logo-header.png" className="logo" alt="Regis Road Runners home" />
      </a>
      <CSSTransition
        in={!isSmallScreen || isNavVisible}
        timeout={350}
        classNames="nav-animation"
        unmountOnExit
      >
        <nav
          id={NAV_ID}
          className={`nav ${small || isNavVisible ? 'nav-links__black' : 'nav-links__white'}`}
          aria-label="Main navigation"
        >
          <a href="#about-us" onClick={closeNav}>About us</a>
          <a href="#events" onClick={closeNav}>Events</a>
          <a href="#membership" onClick={closeNav}>Membership</a>
          <a href="#merchandise" onClick={closeNav}>Merchandise</a>
          <a href="#contactUs" onClick={closeNav}>Contact us</a>
          <div className="header__media-icons">
            <a href="https://www.facebook.com/RegisRoadRunners/" target="_blank" rel="noopener noreferrer" aria-label="Regis Road Runners on Facebook (opens in new tab)">
              <i className={ICON_CLASSES.FACEBOOK} aria-hidden="true" />
            </a>
            <a href="https://www.instagram.com/regisroadrunners28/" target="_blank" rel="noopener noreferrer" aria-label="Regis Road Runners on Instagram (opens in new tab)">
              <i className={ICON_CLASSES.INSTAGRAM} aria-hidden="true" />
            </a>
            <a href="https://strava.app.link/swF1WRHf7wb" target="_blank" rel="noopener noreferrer" aria-label="Regis Road Runners on Strava (opens in new tab)">
              <i className={ICON_CLASSES.STRAVA} aria-hidden="true" />
            </a>
            <a href="mailto:regisroadrunners@gmail.com" aria-label="Email Regis Road Runners">
              <i className={ICON_CLASSES.EMAIL} aria-hidden="true" />
            </a>
          </div>
        </nav>
      </CSSTransition>
      {isSmallScreen && (
        <button
          type="button"
          onClick={toggleNav}
          className={`burger ${small || isNavVisible ? 'burger-black' : 'burger-white'}`}
          aria-expanded={isNavVisible}
          aria-controls={NAV_ID}
          aria-label={isNavVisible ? 'Close menu' : 'Open menu'}
        >
          <span aria-hidden="true">☰</span>
        </button>
      )}
    </header>
  )
}

export default Header
